import Button from "antd/lib/button";
import Space from "antd/lib/space";
import Radio, { RadioChangeEvent } from "antd/lib/radio";
import {
    PauseOutlined,
    ReloadOutlined,
    CaretRightOutlined,
    ArrowRightOutlined,
    ArrowLeftOutlined,
    BarsOutlined,
} from "@ant-design/icons";
import React from "react";
import { useSelector } from "react-redux";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Divider from "antd/lib/divider";
import {
    getConfig,
    getPaused,
    getPace,
    getMenuOpen,
    getDescriptionsVisible,
} from "Redux/selectors";
import { dispatch } from "Redux/store";
import { setGlobal } from "Redux/actions";

interface ActionBarProps {
    togglePause: () => void;
    reset: () => void;
}

const PACE_OPTIONS = [
    { label: "5s", value: 5 },
    { label: "4s", value: 4 },
    { label: "3s", value: 3 },
    { label: "2s", value: 2 },
    { label: "1s", value: 1 },
];

export const ActionBar: React.FC<ActionBarProps> = ({ togglePause, reset }) => {
    const paused = useSelector(getPaused);
    const config = useSelector(getConfig);
    const tick = useSelector(getPace);
    const menuOpen = useSelector(getMenuOpen);
    const descriptionsVisible = useSelector(getDescriptionsVisible);

    const onPaceChange = (e: RadioChangeEvent) => {
        dispatch(setGlobal({ pace: e.target.value }));
    };

    const onMenuToggle = () => {
        dispatch(setGlobal({ menuOpen: !menuOpen }));
    };

    const onDescriptionsToggle = () => {
        dispatch(setGlobal({ descriptionsVisible: !descriptionsVisible }));
    };

    if (!config) return null;

    return (
        <Row justify="space-between" gutter={24} wrap>
            <Col>
                <Space>
                    {menuOpen ? (
                        <Button
                            type="primary"
                            icon={<ArrowLeftOutlined />}
                            onClick={onMenuToggle}
                            size="middle"
                        >
                            Hide Configuration
                        </Button>
                    ) : (
                        <Button
                            type="default"
                            icon={<ArrowRightOutlined />}
                            onClick={onMenuToggle}
                            size="middle"
                        >
                            Show Configuration
                        </Button>
                    )}
                    {descriptionsVisible ? (
                        <Button
                            type="primary"
                            icon={<BarsOutlined />}
                            onClick={onDescriptionsToggle}
                            size="middle"
                        >
                            Hide Descriptions
                        </Button>
                    ) : (
                        <Button
                            type="default"
                            icon={<BarsOutlined />}
                            onClick={onDescriptionsToggle}
                            size="middle"
                        >
                            Show Descriptions
                        </Button>
                    )}
                </Space>
            </Col>
            <Col>
                <Divider type="vertical" />
            </Col>
            <Col>
                <Space align="center" wrap>
                    <Space>
                        <label>Animation speed:</label>
                        <Radio.Group
                            options={PACE_OPTIONS}
                            onChange={onPaceChange}
                            value={tick}
                            optionType="button"
                            buttonStyle="solid"
                            size="middle"
                        />
                    </Space>
                    <Space>
                        {!paused ? (
                            <Button
                                type="primary"
                                icon={<PauseOutlined />}
                                onClick={togglePause}
                                size="middle"
                            >
                                Pause
                            </Button>
                        ) : (
                            <Button
                                type="primary"
                                icon={<CaretRightOutlined />}
                                onClick={togglePause}
                                size="middle"
                            >
                                Resume
                            </Button>
                        )}
                        <Button
                            type="primary"
                            icon={<ReloadOutlined />}
                            onClick={reset}
                            size="middle"
                        >
                            Restart
                        </Button>
                    </Space>
                </Space>
            </Col>
        </Row>
    );
};
